// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2nO5y","search":"Settings_search__242rK","filter":"Settings_filter__2rQyq"};